import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, DodgerBlueColor} from '../../cmsMainStyle'

const webViewerStyle = theme => ({
	webViewer: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 100)
	},

})


export default webViewerStyle